import CompletedStudents from './completed-students'

export default CompletedStudents
